var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 19.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 19.5a2.006 2.006 0 002-2H6a2 2 0 002 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V1.5a1.5 1.5 0 00-3 0v.68C3.63 2.86 2 5.42 2 8.5v5l-2 2v1h16v-1z",
    fill: "#959595"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxOS41Ij4KICAgIDxwYXRoIGQ9Ik0xMiwyMmEyLjAwNiwyLjAwNiwwLDAsMCwyLTJIMTBBMiwyLDAsMCwwLDEyLDIyWm02LTZWMTFjMC0zLjA3LTEuNjQtNS42NC00LjUtNi4zMlY0YTEuNSwxLjUsMCwwLDAtMywwdi42OEM3LjYzLDUuMzYsNiw3LjkyLDYsMTF2NUw0LDE4djFIMjBWMThaIgogICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQgLTIuNSkiCiAgICAgICAgICBmaWxsPSIjOTU5NTk1IgogICAgLz4KPC9zdmc+";
export { SvgBell as ReactComponent };